@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="quote-content">
      <p class="quote-text">{{ s.body }}</p>
      <app-cta-button
        [label]="s.cta.label"
        variant="primary"
        [fragment]="s.cta.fragment"
      />
    </div>
  </app-section-wrapper>
}
